import { createContext, useContext } from 'react';
import type { FC, PropsWithChildren } from 'react';
import type { Categories } from '../../bff-api/categories/model';
import type { CustomPreference } from '../../utils/api/CustomPreference';

export interface SLTServerConfig {
    /**
     * key: object containing action: string, args: string[], converted to JSON
     * value: the URL
     */
    absUrlMap: Record<string, string>;

    /**
     * key: object containing action: string, args: string[], converted to JSON
     * value: the URL
     */
    urlMap: Record<string, string>;

    /**
     * key: custom preference name
     * value: custom preference value
     */
    customPreferences: Partial<Record<CustomPreference, string | number | boolean>>;

    /**
     * key: the content slot ID
     * value: the content slot content
     */
    contentSlots: Record<string, string>;

    /**
     * key: the content asset ID
     * value: the content asset content
     */
    contentAssets: Record<string, string>;

    categories: Categories;

    env: Record<string, string | boolean>;
}

export const EMPTY_SLT_CONFIG_DATA: SLTServerConfig = {
    absUrlMap: {},
    urlMap: {},
    customPreferences: {},
    contentSlots: {},
    contentAssets: {},
    categories: [],
    env: {
        turnToSiteKey: '',
        awsRumApplicationId: '',
        awsRumEnableMonitoring: false,
        awsRumGuestRoleARN: '',
        awsRumIdentityPoolId: '',
    },
};

const SLTConfigContext = createContext<SLTServerConfig>(EMPTY_SLT_CONFIG_DATA);

export const SLTConfigProvider: FC<PropsWithChildren<{ data: SLTServerConfig }>> = ({
    data,
    children,
}) => <SLTConfigContext.Provider value={data}>{children}</SLTConfigContext.Provider>;

export const useSLTConfig = () => useContext(SLTConfigContext);
